export default from './Imposer';



// WEBPACK FOOTER //
// ./src/views/Imposer/index.js